import { IJsonQuery } from '@cian/api-models/common/json_query';

export const defaultState: IJsonQuery = {
  _type: 'flatsale',
  engine_version: { type: 'term', value: 2 },
};
